import { Component, OnInit, Input } from '@angular/core';
import { BasketService } from 'src/app/services/basket.service';
import { Router } from '@angular/router';
import {TimeZoneService} from "../../services/timezone.service";


@Component({
  selector: 'app-add-to-basket',
  templateUrl: './add-to-basket.component.html',
  styleUrls: ['./add-to-basket.component.scss']
})

export class AddToBasketComponent implements OnInit {
  @Input('type') type;
  @Input('item') item;

  // TimeZone related configuration
  public DefaultTimeZone:boolean = true;

  constructor(
    private _basket: BasketService,
    private _router: Router,
    private timezoneService: TimeZoneService
  ) {
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
  }

  addToBasket(){
    this._basket.add(this.type, this.item, 1);
    this._router.navigate(['/basket']);
  }

  ngOnInit() {
  }

}
